import V2IFStakeHistoryTable from 'src/components/HistoryTables/V2IFStakeHistoryTable';
import PortfolioHistoryIFStakingTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryIFStakingTable/PortfolioHistoryIFStakingTableControls';

export default function PortfolioHistoryIFStakingTable() {
	return (
		<div>
			<PortfolioHistoryIFStakingTableControls />
			<V2IFStakeHistoryTable />
		</div>
	);
}
